export const STORAGE_KEYS = {
  checkInLocation: 'mapei-checkin-location',
  flowStage: 'mapei-flow-stage',
  sessionId: 'mapei-session-id',
  activeSessions: 'mapei-active-sessions',
  debugLog: 'mapei-debug-log'
} as const;
